// tslint:disable-next-line: ordered-imports
import { Component, OnInit } from '@angular/core';

import { CorePageBaseComponent } from '../core-page-base.component';
import { CardInstance } from '@workflow/class/card.service';

@Component({
  selector: 'cu-dynamic-page-cards',
  templateUrl: './page-cards.component.html',
  standalone: false
})
export class PageCardsComponent extends CorePageBaseComponent implements OnInit {
  /**
   * visible cards collection
   */
  public get visibleCards(): CardInstance[] {
    return this.page.helper.pageVisibleCards;
  }

  public ngOnInit(): void {}
}
